import {
  IonGrid,
  IonRow,
  IonCol,
  IonCard,
  IonItem,
  IonLabel,
  IonButton,
  IonIcon,
} from "@ionic/react";
import axios from "axios";
import { personOutline } from "ionicons/icons";
import { useEffect, useState } from "react";
import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";

export const KpisSection: React.FC = () => {
  const [counters, setCounters] =
    useState<{ name: string; counter?: string; link?: string; icon: any }[]>();

  const fetchKpis = async () => {
    const [{ data: organizationsCount }, { data: myOrganizationsCount }] = await Promise.all([
      axiosInstance.post(`${api.baseURL}organization/count`, {
        where: { domain: { "!=": "guardservice" } },
      }),
      axiosInstance.post(`${api.baseURL}organization/count`, {
        where: { domain: "guardservice" },
      }),
    ]);

    setCounters([
      {
        name: "Mis empresas",
        counter: myOrganizationsCount,
        //link: "/app/gerencia/mis-empresas",
        icon: personOutline,
      },
      {
        name: "Clientes",
        counter: organizationsCount,
        link: "/app/gerencia/mis-clientes",
        icon: personOutline,
      },
    ]);
  };
  useEffect(() => {
    fetchKpis();
  }, []);
  return (
    <IonGrid style={{ minHeight: "94px" }} class="ion-no-margin">
      <IonRow>
        {counters?.map((counterItem) => (
          <IonCol key={counterItem.name} size="3">
            <IonCard class="ion-no-margin">
              <IonItem lines="none" color="primary">
                <IonIcon icon={counterItem.icon} slot="start"></IonIcon>
                <IonLabel style={{ fontWeight: 500 }}>
                  <h2>{counterItem.name}</h2>
                  <h1>{counterItem.counter}</h1>
                </IonLabel>
                <IonButton
                  slot="end"
                  size="small"
                  color="secondary"
                  class="ion-align-self-start ion-margin-top"
                  routerLink={counterItem.link}
                >
                  Ver todos
                </IonButton>
              </IonItem>
            </IonCard>
          </IonCol>
        ))}
      </IonRow>
    </IonGrid>
  );
};
